import React from 'react';

import { useContext } from '../Context';
import PaymentMethodsContext from './Context';
import Table from './Table';

export default function Index({ enterpriseId }) {
  const { state } = useContext();

  return (
    <>
      {state.viewMode === 'view' && (
        <PaymentMethodsContext enterpriseId={enterpriseId}>
          <div className="ibox-content mt20">
            <h1 className="mb20">Payment Methods</h1>
            <Table />
          </div>
        </PaymentMethodsContext>
      )}
    </>
  );
}
